import React, {useEffect, useState} from "react";
import {webFontList} from "../../utils/fonts";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import StarIcon from '@mui/icons-material/Star';
import {useDispatch, useSelector} from "react-redux";
import {getMaxLineWidth} from "../../utils/helpers";
import {CloseIcon} from "../../assets/icons";
import {setPanelKey} from "../../store/reducers/panleKey";

const FontFamilyPanel = () => {
    const {activeSetting} = useSelector((state) => state.canvas);
    const {canvas} = useSelector((state) => state.canvas);
    const {activeObject} = useSelector((state) => state.canvas);

    const [font, setFont] = useState('Raleway');
    const [query, setQuery] = useState('');
    const [filteredFonts, setFilteredFonts] = useState(webFontList);

    const dispatch = useDispatch()

    useEffect(() => {
        if (activeSetting) {
            const {
                fontFamily
            } = activeSetting;
            setFont(fontFamily);
        }
    }, [activeSetting, activeObject]);

    const changeFont = (item) => {
        const font = item;
        setFont(font);
        activeObject?.set({fontFamily: font});
        canvas.renderAll();
        activeObject?.set({width: getMaxLineWidth(activeObject)});
        canvas.renderAll();
        canvas.fire('object:modified', {target: activeObject});
        // dispatch(setPanelKey('1'))
    };
    const closeTextPanel = () => {
        dispatch(setPanelKey('1'))
    }

    const handleSearch = (e) => {
        const searchQuery = e.target.value;
        setQuery(searchQuery);

        if (searchQuery) {
            const results = webFontList.filter(font =>
                font.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredFonts(results);
        } else {
            setFilteredFonts(webFontList);
        }
    }

    return(
        <div className='font-family-wrapper'>
            <div className='text-header'>
                <span className="heading-text">Select Font</span>
                <span onClick={closeTextPanel} className='cross-icon'><CloseIcon/></span>
            </div>
            <div className="search-section-inner">
                <input
                    type="search"
                    name=""
                    id=""
                    placeholder="Search fonts"
                    className="search-bar"
                    value={query}
                    onChange={handleSearch}
                />
            </div>
            <List
                sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                aria-label="contacts"
            >
                {filteredFonts.sort((a, b) => a.localeCompare(b)).map((item, index) => (
                    <ListItem disableRipple disablePadding key={index} button selected={font === item} onClick={() => changeFont(item)}>
                        <ListItemButton disableRipple>
                            <ListItemIcon>
                                {font === item && <StarIcon />}
                            </ListItemIcon>
                            <ListItemText
                                sx={{ paddingLeft: 0 }}
                                inset
                                primary={
                                    <span style={{ fontFamily: item }}>{item}</span>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>

        </div>
    )
}

export default FontFamilyPanel
